import React, { Suspense, useEffect } from 'react';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';

import { screens } from '../screens';
import { TabNavigator } from './TabNavigator';
import { ProtectedRoute } from './ProtectedRoute';
import { TabLoader } from '../components';

const stack = createBrowserRouter([
  {
    path: '/',
    element: <screens.SignIn />,
    errorElement: <screens.SignIn />,
  },
  {
    path: '/SignIn',
    element: <screens.SignIn />,
  },
  // {
  //   path: '/SignUp',
  //   element: <screens.SignUp />,
  // },
  // {
  //   path: '/VerifyYourPhoneNumber',
  //   element: <screens.VerifyYourPhoneNumber />,
  // },
  {
    path: '/FeedbackSubmitted',
    element: <ProtectedRoute><screens.FeedbackSubmitted /></ProtectedRoute>,
  },
  // {
  //   path: '/FundTransfer',
  //   element: <ProtectedRoute><screens.FundTransfer /></ProtectedRoute>,
  // },
  // {
  //   path: '/OpenNewLoan',
  //   element: <ProtectedRoute><screens.OpenNewLoan /></ProtectedRoute>,
  // },
  {
    path: '/CardMenu',
    element: <ProtectedRoute><screens.Socials /></ProtectedRoute>,
  },
  // {
  //   path: '/ForgotPassword',
  //   element: <ProtectedRoute><screens.ForgotPassword /></ProtectedRoute>,
  // },
  {
    path: '/Feedback',
    element: <ProtectedRoute><screens.Feedback /></ProtectedRoute>,
  },
  {
    path: '/Wallet',
    element: <ProtectedRoute><screens.Wallet /></ProtectedRoute>,
  },
  {
    path: '/withdraw',
    element: <ProtectedRoute><screens.WithdrawRoute /></ProtectedRoute>,
  },
  {
    // Guardarian's hosted checkout redirects deposits back to /deposit?guardarian=...
    // (see Deposit.tsx). Mirror the protected /withdraw route so the deposit return
    // handler mounts instead of falling through to the * catch-all (SignIn).
    path: '/deposit',
    element: <ProtectedRoute><screens.DepositRoute /></ProtectedRoute>,
  },
  {
    path: '/preview/deposit',
    element: <screens.DepositRoute />,
  },
  {
    path: '/preview/withdraw',
    element: <screens.WithdrawRoute />,
  },
  {
    path: '/send',
    element: <ProtectedRoute><screens.WalletSend /></ProtectedRoute>,
  },
  // {
  //   path: '/OpenDeposit',
  //   element: <ProtectedRoute><screens.OpenDeposit /></ProtectedRoute>,
  // },
  // {
  //   path: '/OpenMoneybox',
  //   element: <ProtectedRoute><screens.OpenMoneybox /></ProtectedRoute>,
  // },
  // {
  //   path: '/SignUpAccountCreated',
  //   element: <ProtectedRoute><screens.SignUpAccountCreated /></ProtectedRoute>,
  // },
  // {
  //   path: '/ConfirmationCode',
  //   element: <ProtectedRoute><screens.ConfirmationCode /></ProtectedRoute>,
  // },
  // {
  //   path: '/PaymentFailed',
  //   element: <ProtectedRoute><screens.PaymentFailed /></ProtectedRoute>,
  // },
  {
    path: '/PrizeHistory',
    element: <ProtectedRoute><screens.PrizeHistory /></ProtectedRoute>,
  },
  {
    path: '/PrivacyPolicy',
    element: <ProtectedRoute><screens.PrivacyPolicy /></ProtectedRoute>,
  },
  {
    path: '/TransactionDetails',
    element: <ProtectedRoute><screens.TransactionDetails /></ProtectedRoute>,
  },
  {
    path: '/TransactionHistory',
    element: <ProtectedRoute><screens.TransactionHistory /></ProtectedRoute>,
  },
  // {
  //   path: '/ChangePINCode',
  //   element: <ProtectedRoute><screens.ChangePINCode /></ProtectedRoute>,
  // },
  // {
  //   path: '/IBANPayment',
  //   element: <ProtectedRoute><screens.IBANPayment /></ProtectedRoute>,
  // },
  {
    path: '/FAQ',
    element: <ProtectedRoute><screens.FAQ /></ProtectedRoute>,
  },
  {
    path: '/EditPersonalInfo',
    element: <ProtectedRoute><screens.EditPersonalInfo /></ProtectedRoute>,
  },
  // {
  //   path: '/PaymentSuccess',
  //   element: <ProtectedRoute><screens.PaymentSuccess /></ProtectedRoute>,
  // },
  {
    path: '/ReferralPage',
    element: <ProtectedRoute><screens.ReferralPage /></ProtectedRoute>,
  },
  {
    path: '/ToS',
    element: <ProtectedRoute><screens.ToS /></ProtectedRoute>,
  },
  {
    path: '/Support',
    element: <ProtectedRoute><screens.Support /></ProtectedRoute>,
  },
  // {
  //   path: '/Payments',
  //   element: <ProtectedRoute><screens.Payments /></ProtectedRoute>,
  // },
  // {
  //   path: '/MobilePayment',
  //   element: <ProtectedRoute><screens.MobilePayment /></ProtectedRoute>,
  // },
  // {
  //   path: '/CardDetails',
  //   element: <ProtectedRoute><screens.CardDetails /></ProtectedRoute>,
  // },
  // {
  //   path: '/TopUpPayment',
  //   element: <ProtectedRoute><screens.TopUpPayment /></ProtectedRoute>,
  // },
  // {
  //   path: '/NewPassword',
  //   element: <ProtectedRoute><screens.NewPassword /></ProtectedRoute>,
  // },
  // {
  //   path: '/ForgotPasswordSentEmail',
  //   element: <ProtectedRoute><screens.ForgotPasswordSentEmail /></ProtectedRoute>,
  // },
  {
    path: '/Profile',
    element: <ProtectedRoute><screens.Profile /></ProtectedRoute>,
  },
  {
    path: '/TabNavigator',
    element: (
      <ProtectedRoute>
        <TabNavigator />
      </ProtectedRoute>
    ),
  },
  {
    path: '*',
    element: <screens.SignIn />,
  },
]);

export const StackNavigator: React.FC = () => {
  return (
    <>
      <NavigationAnalytics />
      <Suspense fallback={<TabLoader />}>
        <RouterProvider router={stack} />
      </Suspense>
    </>
  );
};

// Send GA4 page_view on initial load and each route change by subscribing to the data router
const NavigationAnalytics: React.FC = () => {
  useEffect(() => {
    const gtagFn = (window as any).gtag as undefined | ((...args: any[]) => void);
    const gaId: string | undefined = (window as any).GA_MEASUREMENT_ID;
    if (!gtagFn || !gaId) return;

    const sendPageView = () => {
      const location = (stack as any).state?.location;
      const pagePath = location ? location.pathname + location.search : window.location.pathname + window.location.search;
      gtagFn('event', 'page_view', {
        page_path: pagePath,
        page_location: window.location.href,
        page_title: document.title,
      });
    };

    // Send once on mount
    sendPageView();

    // Subscribe to router changes
    const unsubscribe = (stack as any).subscribe ? (stack as any).subscribe(sendPageView) : undefined;

    return () => {
      if (typeof unsubscribe === 'function') unsubscribe();
    };
  }, []);

  return null;
};